import React from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";

import Modal from "../../shared/modal";
import CloseButton from "../../shared/icon-cross";
import { Link } from "react-router-dom";

const ThreeDayDeliveryPopup = ({handleShowPop}) => {
    return (
        <Modal isOpen={true}>
            <div styleName={"styles.modalWrap"}>
                <div styleName={"styles.header"}>
                    <h4 styleName={"styles.heading"}>3 DAY DELIVERY</h4>
                    <span styleName={"styles.close"}><CloseButton type="blue" onClickHandler={handleShowPop}/></span>
                </div>
                <div styleName={"styles.contentWrap"}>
                    <p styleName={"styles.detail"}>Customers in Queensland metro areas, which includes suburbs 100km from the Brishbane city center, may be eligible for faster 3 days delivery.</p>
                    <p styleName={"styles.detail"}>For eligible customers delivery of your car will be within a 3 days period after full payment is recieved and all contractual documents (including any trade-in) as required by Cars24 are signed and completed.</p>
                    <p styleName={"styles.detail"}>Faster 3 days delivery is subject to the delivery provisions in the Cars24 <Link to="/terms-of-sale" target="_blank">terms and conditions of the sale.</Link></p>
                </div>
            </div>
        </Modal>
    );
};

ThreeDayDeliveryPopup.propTypes = {
    handleShowPop: PropTypes.func
};

export default ThreeDayDeliveryPopup;
